import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import ArticlesGridTop from "./ArticlesGridTop";
import Pagination from "@/src/shared/Pagination";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";
import { useArticlesPageContext } from "@/src/features/articles/ArticlesPageContext";

const ArticlesGrid = () => {
  const routes = useBrowserRoutes();
  const { items, totalPages, currentPage } = useArticlesPageContext();
  const { t } = useTranslation();

  const topArticles = items.slice(0, 4);
  const restArticles = items.slice(4, Math.min(9, items.length));

  return (
    <>
      <ArticlesGridTop topArticles={topArticles} />
      <div className="row g-5 mt--15">
        {restArticles.map(item => {
          const detailLink = routes.articleDetail.replace(":slug", item.Slug);

          return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={item.IdGuid}>
              <div className="rbt-card variation-02 rbt-hover">
                <div className="rbt-card-img">
                  <Link href={detailLink}>
                    <Image
                      src={item.ThumbImageUrl}
                      width={450}
                      height={267}
                      priority
                      alt={item.ImageAltText}
                      style={{
                        objectFit: "cover",
                        height: 267
                      }}
                    />
                  </Link>
                </div>
                <div className="rbt-card-body">
                  <h5 className="rbt-card-title">
                    <Link href={detailLink}>{item.Title}</Link>
                  </h5>
                  <div className="rbt-card-bottom">
                    <Link className="transparent-button" href={detailLink}>
                      {t("articleDetails")}
                      <i>
                        <svg width="17" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g stroke="#27374D" fill="none" fillRule="evenodd">
                            <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                            <path strokeLinecap="square" d="M.663 5.572h14.594" />
                          </g>
                        </svg>
                      </i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="row">
        <div className="col-lg-12 mt--60">
          <Pagination totalPages={totalPages} currentPage={currentPage} route={routes.articles} />
        </div>
      </div>
    </>
  );
};

export default ArticlesGrid;
